import { AI_ASSISTANT_CONFIG } from "./ai-assistant-config";

// API Configuration
export const API_BASE_URL =
    process.env.REACT_APP_RAG_API_URL || AI_ASSISTANT_CONFIG.apiUrl;

// UI Configuration
export const SHOW_BRANDING =
    process.env.REACT_APP_SHOW_BRANDING === "true" ||
    AI_ASSISTANT_CONFIG.showBranding;

export const DEFAULT_THEME =
    (process.env.REACT_APP_DEFAULT_THEME as "light" | "dark") ||
    AI_ASSISTANT_CONFIG.defaultTheme;

export const IS_STANDALONE =
    process.env.REACT_APP_IS_STANDALONE === "true" ||
    AI_ASSISTANT_CONFIG.isStandalone;

// Branding Configuration
export const APP_NAME =
    process.env.REACT_APP_APP_NAME || AI_ASSISTANT_CONFIG.appName;
export const APP_DESCRIPTION =
    process.env.REACT_APP_APP_DESCRIPTION || AI_ASSISTANT_CONFIG.appDescription;
export const BRAND_NAME =
    process.env.REACT_APP_BRAND_NAME || AI_ASSISTANT_CONFIG.brandName;
export const APP_LOGO =
    process.env.REACT_APP_APP_LOGO || AI_ASSISTANT_CONFIG.appLogo;
export const MODEL_NAME =
    process.env.REACT_APP_MODEL_NAME || AI_ASSISTANT_CONFIG.modelName;

// UI Text Configuration
export const WELCOME_TITLE =
    process.env.REACT_APP_WELCOME_TITLE || AI_ASSISTANT_CONFIG.welcomeTitle;
export const WELCOME_DESCRIPTION =
    process.env.REACT_APP_WELCOME_DESCRIPTION ||
    AI_ASSISTANT_CONFIG.welcomeDescription;
export const INPUT_PLACEHOLDER =
    process.env.REACT_APP_INPUT_PLACEHOLDER ||
    AI_ASSISTANT_CONFIG.inputPlaceholder;
export const FOOTER_TEXT =
    process.env.REACT_APP_FOOTER_TEXT || AI_ASSISTANT_CONFIG.footerText;

// Example Prompts Configuration
export type ExamplePrompt = {
    question: string;
    why: string;
    tier: "Basic" | "Procedural" | "Advanced" | "Analytical";
};

const DEFAULT_EXAMPLE_PROMPTS: ExamplePrompt[] = [
    {
        question:
            "What is difference between a protocol deviation and violation?",
        why: "Basic terminology — tests single-document retrieval",
        tier: "Basic",
    },
    {
        question: "What are the essential elements of informed consent?",
        why: "Comprehensive lists — demonstrates structured extraction",
        tier: "Basic",
    },
    {
        question:
            "What training is required before obtaining informed consent?",
        why: "Multi-document — cross-references training & consent requirements",
        tier: "Procedural",
    },
    {
        question: "How should I prepare for an FDA audit or inspection?",
        why: "Practical guidance — synthesizes audit & documentation requirements",
        tier: "Procedural",
    },
    {
        question:
            "What are my responsibilities as a principal investigator per GCP?",
        why: "Role-based synthesis — aggregates PI duties from multiple sources",
        tier: "Advanced",
    },
    {
        question: "Walk me through reporting a serious adverse event",
        why: "Step-by-step procedures — demonstrates sequential guidance",
        tier: "Advanced",
    },
    {
        question: "Compare monitoring visits and FDA audit preparation",
        why: "Analytical comparison — shows cross-topic reasoning",
        tier: "Analytical",
    },
    {
        question: "A participant wants to withdraw consent—what do I do?",
        why: "Scenario troubleshooting — tests real-world application",
        tier: "Analytical",
    },
];

export const getExamplePrompts = (): ExamplePrompt[] => {
    return AI_ASSISTANT_CONFIG.examplePrompts;
};
